import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; // Importation

const EditMinistreSuccessifs = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [ministreData, setMinistreData] = useState({
    nomprenom: '',
    categorie: '',
    du: '',
    au: '',
    personnelId: null,
    observation: null,
    chefministre: '',
  });
  const [error, setError] = useState(''); // Pour gérer la suppression de l'image existante

  const [personnelSuggestions, setPersonnelSuggestions] = useState([]);

  useEffect(() => {
    const fetchMinistre = async () => {
      try {
        const response = await axios.get(`ministresuccessifs/${id}`);
        const ministreData = response.data;

        setMinistreData({
          ...ministreData,
          nomprenom: ministreData.nomprenom || null,
          categorie: ministreData.categorie || null,
          du: ministreData.du || null,
          au: ministreData.au || null,
          personnelId: ministreData.personnelId || null,
          observation: ministreData.observation || null,
          chefministre: ministreData.personnel ? ministreData.personnel.nomprenom : null,
        });

        if (ministreData.personnelId) {
          const personnelResponse = await axios.get(`personnel/show/${ministreData.personnelId}`);
          setMinistreData({
            ...ministreData,
            chefministre: personnelResponse.data.nomprenom || null,
          });
        }
      } catch (error) {
        console.error('Voir > EditMinistre.js eseEffect() du route brigade api/id/show/ :', error);
      }
    };
    fetchMinistre();
  }, []);

  // Fetch personnel suggestions based on input
  const handleChefMinistreChange = async (e) => {
    const query = e.target.value.toLowerCase().trim();

    setMinistreData({
      ...ministreData,
      chefministre: e.target.value,
    });

    if (query.length >= 1) {
      // Commencer la recherche après 2 caractères
      try {
        const res = await axios.get(`personnel`, {
          params: {
            nomprenom: query,
          },
        });
        const listePersonnels = res.data.personnels || res.data.data || res.data; // à ajuster selon la vraie clé
        const filtreResultat = listePersonnels
          .filter((personnel) => {
            const nomComplet = (personnel.nomprenom || '').toLowerCase();
            return query.split(' ').every((term) => nomComplet.includes(term));
          })
          .slice(0, 10);
        setPersonnelSuggestions(filtreResultat);
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions de personnels', error);
      }
    } else {
      setPersonnelSuggestions([]);
      setMinistreData({
        ...ministreData,
        chefministre: null,
        personnelId: null,
      });
    }
  };

  // Handle personnel selection
  const handlePersonnelSelect = (personnel) => {
    setMinistreData({
      ...ministreData,
      chefministre: personnel.nomprenom,
      personnelId: personnel.id,
    });
    setPersonnelSuggestions([]);
  };

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setMinistreData({ ...ministreData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append('ministreData', JSON.stringify(ministreData));

    const response = await axios.put(`ministresuccessifs/edit/${id}`, formData, {
      headers: {
        'Content-Type': 'application/json', // Spécifier que c'est du JSON
      },
    });

    try {
      if (response.data.success) {
        toast.success('Enregistrement Ministre avec succès !', {
          position: 'bottom-right',
        });
        setTimeout(() => {
          navigate('/listministresuccessifs');
        }, 2000);
      }
    } catch (error) {
      toast.error(error.response.data.error, {
        position: 'bottom-right',
      });
    }
  };

  return (
    <div className="container mt-5 pt-3 mb-4 ">
      <div className='bg-warning col-md-12 p-3 text-center' ><h1>Modification Ministre</h1>  </div>
      <div className="row">
        <div className="col ">{error && <div className="alert alert-danger "> {error} </div>}</div>
      </div>
      <form encType="multipart/form-data" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col">
            <label htmlFor="nomprenom">Nom et prénoms</label>
            <input value={ministreData.nomprenom} onChange={handleChange} type="text" className="form-control" id="nomprenom" name="nomprenom" />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="au">Au :</label>
            <input className="form-control" id="au" name="au" rows="3" value={ministreData.au} onChange={handleChange} placeholder="Année" />
          </div>
          <div className="col">
            <label htmlFor="du">Du : </label>
            <input className="form-control" id="du" name="du" rows="3" value={ministreData.du} onChange={handleChange} placeholder="Année" />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="categorie">Observation : </label>
            <input type="text" className="form-control" id="categorie" name="categorie" value={ministreData.categorie} onChange={handleChange} />
          </div>
          <div className="col">
            <div>
              <label>Personnel</label>
              <input type="text" name="chefministre" value={ministreData.chefministre} onChange={handleChefMinistreChange} placeholder="Entrez le nom personnel" className="form-control" />
              {personnelSuggestions.length > 0 && (
                <ul>
                  {personnelSuggestions.map((personnel) => (
                    <li className="bg-primary" key={personnel.id} onClick={() => handlePersonnelSelect(personnel)} style={{ cursor: 'pointer' }}>
                      {personnel.nomprenom}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        <button type="submit" className="btn btn-primary mt-4  ">
          Enregistrer les modifications
        </button>
      </form>
    </div>
  );
};

export default EditMinistreSuccessifs;
